import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import * as Styled from './styles';
import Button from '../Button';
import { apiClientInstance } from '../../api/axiosClient';
import { useAuth } from '../../hooks/useAuth';
import { useEntry } from '../../hooks/useEntry';
import { metricsApi } from '../../api/metricsApi';
import { useError } from '../../hooks/useError';
import apiMessageToProductMessage from '../../api/apiMessageToProductMessage';

export const EnterPrompt = ({ sweepId }) => {
    const { authStore } = useAuth();
    const { setEntry } = useEntry();
    const { setError } = useError();

    const handleEnter = () => {
        // TODO should use requests.getEntryBySweepId()
        apiClientInstance
            .post(
                `/client/sweepstake/${sweepId}/entry`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authStore.productToken}`
                    }
                }
            )
            .then(res => {
                const id = get(res, 'data.selection.id', null);
                const name = get(res, 'data.selection.name', null);
                const metaData = get(res, 'data.selection.metaData', null);

                setEntry({
                    id,
                    name,
                    metaData,
                    hasEntered: true
                });
            })
            .catch(async err => {
                let errorMessage;
                if (err.response) {
                    errorMessage = get(
                        err,
                        'response.data.message',
                        'Unknown error'
                    );
                } else {
                    errorMessage = err.message;
                }

                await metricsApi.errorMetric(
                    'handleEnter',
                    get(err, 'response.status', 500),
                    errorMessage
                );
                setError(apiMessageToProductMessage(errorMessage));
            });
    };

    return (
        <Styled.EnterPromptWrapper>
            <Styled.EnterButtonWrapper>
                <Button
                    type="default"
                    buttonText="ENTER NOW"
                    onClick={handleEnter}
                    disabled={false}
                />
            </Styled.EnterButtonWrapper>
        </Styled.EnterPromptWrapper>
    );
};

EnterPrompt.defaultProps = {
    sweepId: null
};

EnterPrompt.propTypes = {
    sweepId: PropTypes.string
};

export default EnterPrompt;
